"use strict";
var $ = require("../internals/export");
var toObject = require("../internals/to-object");
var nativeKeys = require("../internals/object-keys");
var fails = require("../internals/fails");
var FAILS_ON_PRIMITIVES = fails(function() {
  nativeKeys(1);
});
$({ target: "Object", stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});
